import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import back from "../../../assets/back.svg";
import { customerVersionDetial } from "../../../redux/actions/customerActions";
import { JSONTree } from "react-json-tree";
import moment from "moment";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const CustomerVersionHistoryDetail = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [customerVersionHistoryData, setCustomerVersionHistoryData] =
    useState(null);
  const [customerVersionHistoryOldData, setCustomerVersionHistoryOldData] =
    useState();
  const [customerVersionHistoryNewData, setCustomerVersionHistoryNewData] =
    useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    console.log(state);
    dispatch(customerVersionDetial(state, onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    setLoading(false);
    console.log(data.data.data.doctorVersion);
    setCustomerVersionHistoryData(data.data.data);
    setCustomerVersionHistoryOldData(data.data.data.doctorVersion.old_data);
    setCustomerVersionHistoryNewData(data.data.data.doctorVersion.new_data);
  };
  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };

  const theme = {
    scheme: "monokai",
    author: "wimer hazenberg (http://www.monokai.nl)",
    base00: "#272822",
    base01: "#383830",
    base02: "#49483e",
    base03: "#75715e",
    base04: "#a59f85",
    base05: "#f8f8f2",
    base06: "#f5f4f1",
    base07: "#f9f8f5",
    base08: "#f92672",
    base09: "#464646",
    base0A: "#f4bf75",
    base0B: "#464646",
    base0C: "#a1efe4",
    base0D: "#464646",
    base0E: "#ae81ff",
    base0F: "#cc6633",
    nestedKeyLabel: {
      fontSize: "14px",
    },
    value: {
      fontSize: "14px",
    },
  };

  const data = [
    {
      heading: "Jivini’s Doctor Code",
      title:
        customerVersionHistoryData?.is_pharmacy &&
        customerVersionHistoryData?.code
          ? customerVersionHistoryData?.is_pharmacy &&
            customerVersionHistoryData?.code
          : "--",
    },
    {
      heading: "Jivini’s Pharmacy Code",
      title:
        !customerVersionHistoryData?.is_pharmacy &&
        customerVersionHistoryData?.code
          ? !customerVersionHistoryData?.is_pharmacy &&
            customerVersionHistoryData?.code
          : "--",
    },
    {
      heading: "Doctor Name",
      title: customerVersionHistoryData?.name
        ? customerVersionHistoryData?.name
        : "--",
    },
    {
      heading: "Pharmacy Name",
      title: customerVersionHistoryData?.doctorAttachPharmacy?.pharmacy
        ?.pharmacy_name
        ? customerVersionHistoryData?.doctorAttachPharmacy?.pharmacy
            ?.pharmacy_name
        : "--",
    },
    {
      heading: "Updated By",
      title: customerVersionHistoryData?.updatedByAdmin
        ? customerVersionHistoryData?.updatedByAdmin
        : "--",
    },
    {
      heading: "Updated Date",
      title: customerVersionHistoryData?.updatedAt
        ? moment(customerVersionHistoryData?.updatedAt).format(
            "DD MMM YYYY, HH:mm A"
          )
        : "--",
    },
  ];
  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/customers/onboarded-doctors",
      breadcrumb: " / customers / onboarded doctor",
    },
    {
      path: "/customers/onboarded-doctors/version-history-detail/:id",
      breadcrumb: customerVersionHistoryData?.code
        ? ` / ${customerVersionHistoryData?.code} - version history`
        : " / version history",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });
  return (
    <>
      {loading ? (
        <LoadingSpinnerTable />
      ) : (
        <div className="products-page">
          <div className="products-main-div">
            <div className="mx-3">
              {breadcrumbs.map(({ match, breadcrumb }) => (
                <NavLink
                  key={match.pathname}
                  to={match.pathname}
                  className="header-route-page fw_400 cursor_pointer"
                >
                  <span className="fs_18">{breadcrumb}</span>
                </NavLink>
              ))}
            </div>
            <div className="products-main-list my-2 py-1">
              <div className="search-container d-flex justify-content-between ">
                <div
                  className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                  onClick={() => navigate(-1)}
                >
                  <img src={back} alt="back_btn" />
                  <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                    BACK
                  </span>
                </div>
              </div>
              <div className="pt-3 mx-2 px-4 row">
                {data.map((item, index) => (
                  <div className="mb-2 col-8 col-sm-6 col-md-4 col-xxl  customer-heading-container">
                    <h5 className="dark_grey_color text-nowrap fs_15 fw_500 m-0">
                      {item.heading}
                    </h5>
                    <p className={` fs_16 fn_Nunito text-nowrap fw_600`}>
                      {item.title}
                    </p>
                  </div>
                ))}
              </div>
              <div className=" mx-3 d-none d-xl-block form-sub-details my-3 mb-4">
                <div className="d-flex justify-content-between">
                  <div className="col-5 mx-4 ">JSON Old Data</div>
                  <div className="col-6">
                    <span className="ms-4 ps-2">JSON New Data</span>
                  </div>
                </div>
              </div>

              <div className="d-xl-flex flex-column flex-md-row justify-content-between col-xl-11 gap-xxl-4 mt-5  mt-xl-0">
                <div
                  className="white_shade_bg col-10 col-xl-6 my-2 mx-auto mx-xl-3 px-xl-2 ms-xl-4 ps-xl-3"
                  style={{ minHeight: "30rem" }}
                >
                  <div>
                    <h6
                      className="px-3 py-3 my-auto"
                      style={{
                        backgroundColor: "#E7E5FF",
                        borderTopLeftRadius: "10px",
                        borderTopRightRadius: "10px",
                      }}
                    >
                      Old Data
                    </h6>
                    <div className="">
                      <div className="admin_aprvls_vrsn_hstry_data_container  mt-3 pt-3 px-3">
                        <>
                          {customerVersionHistoryOldData === null ? (
                            <>Empty data</>
                          ) : (
                            <>
                              <JSONTree
                                theme={theme}
                                data={customerVersionHistoryOldData}
                              />
                              ;
                            </>
                          )}
                        </>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="col-10 col-xl-6 my-2 mx-xl-3 mx-auto"
                  style={{ minHeight: "30rem" }}
                >
                  <div>
                    <h6
                      className="px-3 py-3 my-auto"
                      style={{
                        backgroundColor: "#E7E5FF",
                        borderTopLeftRadius: "10px",
                        borderTopRightRadius: "10px",
                      }}
                    >
                      New Data
                    </h6>
                    <div className="">
                      <div className="admin_aprvls_vrsn_hstry_data_container  mt-3 pt-3 px-3">
                        <>
                          {customerVersionHistoryNewData === null ? (
                            <>Empty data</>
                          ) : (
                            <>
                              <JSONTree
                                theme={theme}
                                data={customerVersionHistoryNewData}
                              />
                              ;
                            </>
                          )}
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomerVersionHistoryDetail;
